import { render, staticRenderFns } from "./AdminStudents.vue?vue&type=template&id=201003dc&scoped=true"
import script from "./AdminStudents.vue?vue&type=script&lang=js"
export * from "./AdminStudents.vue?vue&type=script&lang=js"
import style0 from "./AdminStudents.vue?vue&type=style&index=0&id=201003dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201003dc",
  null
  
)

export default component.exports